document.addEventListener('DOMContentLoaded', function () {
    const cartDrawer = document.getElementById('CartDrawer');
    const cartPopupWrapper = document.querySelector('.cart-popup-wrapper');
    const closeButton = document.querySelector('.popup-drawer__close-button');
    const popupImg = document.querySelector('.cart-popup-img');
  
    if (cartDrawer && cartPopupWrapper) {
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
            if (mutation.attributeName === 'class') {
                const classList = mutation.target.classList;
                if (classList.contains('drawer--is-open')) {
                cartPopupWrapper.style.display = 'block';
                } else {
                cartPopupWrapper.style.display = 'none';
                }
            }
            }
        });
      observer.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
    }
  
    if (closeButton && cartPopupWrapper) {
        closeButton.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            cartPopupWrapper.style.display = 'none'; 
        });
    }
    if (popupImg) {
        popupImg.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }
    
    if (cartPopupWrapper) {
        cartPopupWrapper.addEventListener('click', function (e) {
          e.stopPropagation();
        });
      }
});
  